document.addEventListener('mouseenter', function (e) {
    if (!e.target || typeof e.target.closest !== 'function') return; 

    const target = e.target.closest('.product-card--details .swatches--container a:not(.swatch.active)');
    if (target) {
      let img_class = `.image-${target.dataset.handle}`;
			let product_item = target.closest('.product-card--root');
			//console.log('product_item',product_item, img_class, product_item.querySelector(img_class));
			if (product_item && product_item.querySelector(img_class)){
				let active_image = product_item.querySelector(img_class);
				//console.log('active_image',active_image);
				active_image?.classList.add('active');
			}
    }
  },
  true 
);

document.addEventListener('mouseleave', function (e) {
    if (!e.target || typeof e.target.closest !== 'function') return; 

    const target = e.target.closest('.product-card--details .swatches--container a:not(.swatch.active)');
    if (target) {
      let img_class = `.image-${target.dataset.handle}`;
			let product_item = target.closest('.product-card--root');
			
			if (product_item && product_item.querySelector('img.active')){
				let active_image = product_item.querySelector('img.active');
				//console.log('active_image remove',active_image);
				active_image?.classList.remove('active');
			}
    }
  },
  true 
);